import { render, staticRenderFns } from "./PhpMyAdminView.vue?vue&type=template&id=eafec09c&scoped=true&"
import script from "./PhpMyAdminView.vue?vue&type=script&lang=js&"
export * from "./PhpMyAdminView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eafec09c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eafec09c')) {
      api.createRecord('eafec09c', component.options)
    } else {
      api.reload('eafec09c', component.options)
    }
    module.hot.accept("./PhpMyAdminView.vue?vue&type=template&id=eafec09c&scoped=true&", function () {
      api.rerender('eafec09c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/mysql/databases/PhpMyAdminView.vue"
export default component.exports